var image_upload_default = {
  "container": "GJ4Re",
  "disabled": "vifmd",
  "imageInput": "tDgsu",
  "overlay": "LpsFn",
  "text": "_3K0jZ",
  "shown": "_8G-Ez",
  "hide": "rXrg1",
  "spinner": "_4Ey4m",
  "spin": "_2qArb"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
